export default __webpack_public_path__ + "static/media/logo-us-claires.3b5ca8a0.svg";